import { Resource } from "react-admin";
import React from "react";

export default <Resource name="operation_types" />;



// WEBPACK FOOTER //
// ./src/resources/OperationTypes/index.js